import React from "react";

const EditableField = ({
  value,
  isEditing,
  editedValue,
  onValueChange,
  onBlur,
  onKeyDown,
}) => {
  return (
    <div className={`value ${isEditing ? "flex-1" : ""}`}>
      {isEditing ? (
        <input
          type="text"
          value={editedValue}
          onChange={(e) => onValueChange(e.target.value)}
          onBlur={onBlur}
          onKeyDown={onKeyDown}
          className="input fullwidth"
          autoFocus
        />
      ) : (
        <p>{value}</p>
      )}
    </div>
  );
};

export default EditableField;
